export enum CONTACT_REQUEST_STATUS {
    new = 'NEW',
    close = 'CLOSED',
    refuse = 'REFUSED',
    accept = 'ACCEPTED',
    complete = 'COMPLETED',
    withdrawal = 'WITHDRAWAL'
}